exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /data/jenkins_data/workspace/NaturallyPlus_WEB_UAT/src/app/use-method-list/use-method-list.component.css
// module id = ../../../../../src/app/use-method-list/use-method-list.component.css
// module chunks = main